import type React from "react";
import { useCallback } from "react";
import * as prod from "react/jsx-runtime";
import rehypeReact from "rehype-react";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import { unified } from "unified";

/**
 * Markdownコンテンツを正規化
 * - ダブルクオーテーションで囲まれている場合は取り除く
 * - エスケープシーケンスを変換
 */
const normalizeMarkdownContent = (content: string): string => {
  let normalized = content;
  if (normalized.startsWith('"') && normalized.endsWith('"')) {
    try {
      normalized = JSON.parse(normalized);
    } catch {
      // パースできない場合はそのまま使用
    }
  }
  return normalized.replace(/\\n/g, "\n").replace(/\\"/g, '"').replace(/\\t/g, "\t");
};

/**
 * Markdown描画用カスタムフック
 */
export const useMarkdownRenderer = () => {
  const renderMarkdown = useCallback((content: string): React.ReactNode => {
    if (!content) return null;
    try {
      return unified()
        .use(remarkParse)
        .use(remarkGfm)
        .use(remarkRehype)
        .use(rehypeReact, prod)
        .processSync(normalizeMarkdownContent(content)).result as React.ReactNode;
    } catch {
      return content;
    }
  }, []);

  return { renderMarkdown, normalizeMarkdownContent };
};

export { normalizeMarkdownContent };
